import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { Text } from 'recharts';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import { getAccounts } from '../../actions/Accounts';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { getMenuSetting, updateMenuSetting } from '../../actions/GochiMenus';

const styles = () => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    flexGrow: 1,
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  pagerTitle: {
    padding: '20px 10px 10px'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleGroup: {
    marginBottom: 20
  },
  pagerInDiv: {
    padding: 20
  },
  pagerActions: {
    padding: '15px 10px',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  bold: {
    fontWeight: 'bold'
  },
  font20: {
    fontSize: 20
  },
  font16: {
    fontSize: 16
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12,
    paddingTop: 10
  },
  btnBack: {
    marginRight: 10
  },
  ml10: {
    marginLeft: 10
  },
  labelRadio: {
    fontSize: 14
  }
});

const priceForSetting = [1000, 3000, 5000, 10000];

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      cognitoUserId: state.cognitoUser.cognitoUserId
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, getMenuSetting, updateMenuSetting },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('isInsertGochiTicket', 'setIsInsertGochiTicket', null),
  withState('insertPrice', 'setInsertPrice', {}),
  withState('disablePrice', 'setDisablePrice', {}),
  withState('isUseGochiPrice', 'setIsUseGochiPrice', null),
  withState('isSetData', 'setIsSetData', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      if (this.props.menuSetting && !this.props.isSetData) {
        const isFirstSettingMenu =
          !_.get(this.props.menuSetting, 'allowMenuPrice', false) &&
          !_.get(this.props.menuSetting, 'autoGenMenuDefault', false) &&
          !_.get(this.props.menuSetting, 'ticketCategories', false);
        if (!isFirstSettingMenu) {
          this.props.setIsSetData(true);
          this.props.setIsInsertGochiTicket(
            _.get(this.props.menuSetting, 'autoGenMenuDefault', false) === 1
          );
          this.props.setIsUseGochiPrice(
            _.get(this.props.menuSetting, 'allowMenuPrice', false) === 1
          );
          this.props.setInsertPrice(
            _.reduce(
              _.get(this.props.menuSetting, 'ticketCategories', []),
              (res, val) => {
                res[val] = true;
                return res;
              },
              {}
            )
          );
          this.props.setDisablePrice(
            _.reduce(
              _.get(this.props.menuSetting, 'ticketCategories', []),
              (res, val) => {
                res[val] = true;
                return res;
              },
              {}
            )
          );
        }
      }
    }
  })
);

const Main = enhance(
  ({
    classes,
    openProgress,
    updateOpenProgress,
    updateLoading,
    loading,
    resultMessage,
    setResultMessage,
    isInsertGochiTicket,
    setIsInsertGochiTicket,
    insertPrice,
    setInsertPrice,
    isUseGochiPrice,
    setIsUseGochiPrice,
    shopId,
    setOpenMenuSettingModal,
    disablePrice,
    actions,
    menuSetting,
    isEdit,
    setDataToParrent,
    handleChangePage
  }) => {
    const progressOkAction = () => {
      if (handleChangePage && typeof handleChangePage === 'function') {
        handleChangePage(null, 1, 10);
      }
      updateOpenProgress(false);
      setOpenMenuSettingModal(false);
    };

    const settingMenu = () => {
      updateOpenProgress(true);
      updateLoading(true);
      const dataParams = {
        params: {},
        shopId
      };
      const allowMenuPrice = isUseGochiPrice ? 1 : 0;
      if (allowMenuPrice !== parseInt(menuSetting.allowMenuPrice, 10)) {
        dataParams.params.allowMenuPrice = allowMenuPrice;
      }
      const autoGenMenuDefault = isInsertGochiTicket ? 1 : 0;
      if (autoGenMenuDefault !== parseInt(menuSetting.autoGenMenuDefault, 10)) {
        dataParams.params.autoGenMenuDefault = autoGenMenuDefault;
      }
      const ticketCategoriesVal = _.reduce(
        insertPrice,
        (result, value, key) => {
          if (value) {
            result.push(parseInt(key, 10));
          }
          return result;
        },
        []
      );
      const ticketCategoriesData = _.get(menuSetting, 'ticketCategories', []);
      const ticketCategories =
        ticketCategoriesData && ticketCategoriesData.length > 0
          ? ticketCategoriesVal.filter(el => {
              return !ticketCategoriesData.includes(el);
            })
          : ticketCategoriesVal;
      if (ticketCategories.length > 0) {
        dataParams.params.ticketCategories = ticketCategories;
        dataParams.params.autoGenMenuDefault = autoGenMenuDefault;
      }
      if (_.size(dataParams.params) > 0) {
        actions
          .updateMenuSetting(dataParams)
          .then(data => {
            if (data.type === 'UPDATE_MENU_SETTING_SUCCESS') {
              actions
                .getMenuSetting(shopId)
                .then(menuSettingData => {
                  if (menuSettingData.type === 'GET_MENU_SETTING_SUCCESS') {
                    // updateOpenProgress(false);
                    if (
                      setDataToParrent &&
                      typeof setDataToParrent === 'function'
                    ) {
                      setDataToParrent(menuSettingData.payload);
                    }
                    setResultMessage(data.payload);
                    updateLoading(false);
                  }
                })
                .catch(() => {
                  updateOpenProgress(false);
                  updateLoading(false);
                  setOpenMenuSettingModal(false);
                });
            }
          })
          .catch(() => {
            updateOpenProgress(false);
            updateLoading(false);
            setOpenMenuSettingModal(false);
          });
      } else {
        updateOpenProgress(false);
        updateLoading(false);
        setOpenMenuSettingModal(false);
      }
    };

    const handleChangePrice = event => {
      setInsertPrice({
        ...insertPrice,
        [event.target.name]: event.target.checked
      });
    };

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <div className={classes.page}>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerTitle}>
              <Text className={[classes.font20, classes.bold]}>
                メニューの標準設定
              </Text>
              <Typography className={classes.font14}>
                メニュー情報を選択してください。
              </Typography>
            </div>
            <div className={classes.pagerInDiv}>
              <div className={classes.titleGroup}>
                <Typography className={classes.font16}>
                  金券として使用できる「ごちチケット」をメニューに自動作成しますか？
                </Typography>
                <Typography className={classes.font12}>
                  ※登録後変更はできません
                </Typography>
              </div>
              <RadioGroup
                value={isInsertGochiTicket}
                onChange={e => {
                  setIsInsertGochiTicket(e.target.value === 'true');
                }}
              >
                <FormControlLabel
                  value
                  control={<Radio color="primary" />}
                  disabled={isEdit}
                  label={
                    <Typography className={classes.labelRadio}>
                      作成する
                    </Typography>
                  }
                />
                <FormControlLabel
                  value={false}
                  control={<Radio color="primary" />}
                  disabled={isEdit}
                  label={
                    <Typography className={classes.labelRadio}>
                      作成しない
                    </Typography>
                  }
                />
              </RadioGroup>
            </div>
            <Divider />
            {isInsertGochiTicket && (
              <>
                <div className={classes.pagerInDiv}>
                  <div className={classes.titleGroup}>
                    <Typography className={classes.font16}>
                      作成したい金額のチケットを以下から選択してください（複数可）
                    </Typography>
                    <Typography className={classes.font12}>
                      ※登録後選択した金額は変更できません。
                      <br />
                      未選択のものは後から追加できます。
                    </Typography>
                  </div>
                  {priceForSetting.map(price => (
                    <FormControlLabel
                      key={_.random(true)}
                      value={price}
                      disabled={disablePrice[price]}
                      control={
                        <Checkbox
                          color="primary"
                          checked={!!insertPrice[price]}
                          onChange={handleChangePrice}
                          name={price.toString()}
                        />
                      }
                      label={
                        <Typography className={classes.labelRadio}>
                          {`${price}円`}
                        </Typography>
                      }
                    />
                  ))}
                </div>
                <Divider />
              </>
            )}
            <div className={classes.pagerInDiv}>
              <div className={classes.titleGroup}>
                <Typography className={classes.font16}>
                  お客様が任意の金額のチケットを購入できる「お値段ごち」を利用しますか？（開店後いつでも設定が変更できます）
                </Typography>
                <Typography className={classes.font12}>
                  ※開店後いつでも設定が変更できます
                </Typography>
              </div>
              <RadioGroup
                value={isUseGochiPrice}
                onChange={e => {
                  setIsUseGochiPrice(e.target.value === 'true');
                }}
              >
                <FormControlLabel
                  value
                  control={<Radio color="primary" />}
                  label={
                    <Typography className={classes.labelRadio}>
                      利用する
                    </Typography>
                  }
                />
                <FormControlLabel
                  value={false}
                  control={<Radio color="primary" />}
                  label={
                    <Typography className={classes.labelRadio}>
                      利用しない
                    </Typography>
                  }
                />
              </RadioGroup>
            </div>
            <Divider />
            <div className={classes.pagerActions}>
              <div className={classes.btnBack}>
                <Button
                  variant="text"
                  color="primary"
                  onClick={() => setOpenMenuSettingModal(false)}
                >
                  <Text className={classes.bold}>キャンセル</Text>
                </Button>
              </div>
              <div className={classes.btnSubmit}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={settingMenu}
                >
                  <Text className={classes.bold}>登録</Text>
                </Button>
              </div>
            </div>
          </Paper>
        </div>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
